/**
 * トグルスイッチコンポーネント
 */

interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  disabled?: boolean
}

export function Toggle({ checked, onChange, label, disabled = false }: ToggleProps) {
  return (
    <label style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1
    }}>
      <div
        onClick={() => !disabled && onChange(!checked)}
        style={{
          width: '2.75rem',
          height: '1.5rem',
          backgroundColor: checked ? '#3b82f6' : '#d1d5db',
          borderRadius: '9999px',
          position: 'relative',
          transition: 'background-color 0.2s',
          cursor: disabled ? 'not-allowed' : 'pointer',
          flexShrink: 0
        }}
      >
        <div
          style={{
            width: '1.25rem',
            height: '1.25rem',
            backgroundColor: 'white',
            borderRadius: '9999px',
            position: 'absolute',
            top: '0.125rem',
            left: checked ? '1.375rem' : '0.125rem',
            transition: 'left 0.2s',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
          }}
        />
      </div>
      {label && (
        <span style={{
          fontSize: '0.875rem',
          fontWeight: 500,
          color: '#374151'
        }}>
          {label}
        </span>
      )}
    </label>
  )
}
